import React from 'react';

import {ToolsRibbonComponent} from 'src/components/selection-toolbar/tools-ribbon-component';

import {Body, Table} from '@pb/kit-component-table';

import {NoResults} from './no-results';
import {VendorManagementPagination} from './vendor-management-pagination';
import {VendorManagementTableHeader} from './vendor-management-table-header';
import {VendorManagementTableRow} from './vendor-management-table-row';

import type {VendorTableRow} from '../hooks/useVendorTableData';

type Props = {
    vendors: VendorTableRow[],
    hasActiveFilter: boolean,
    totalCount: number,
    pageIds: Array<number | string>,
    selectedCount: number,
    allSelected: boolean,
    pageSelectedCount: number,
    onSelectAll: () => void,
    onSelectPage: () => void,
    onClearSelection: () => void,
    pagination: {page: number, size: number},
    onChangePage: (page: number) => void,
    onChangePageSize: (size: number) => void,
    isSelected: (id: string) => boolean,
    onToggle: (id: string, index: number, checked: boolean, shiftKey: boolean) => void,
};

export const VendorManagementTable: React.FC<Props> = ({
    vendors,
    hasActiveFilter,
    totalCount,
    pageIds,
    selectedCount,
    allSelected,
    pageSelectedCount,
    onSelectAll,
    onSelectPage,
    onClearSelection,
    pagination,
    onChangePage,
    onChangePageSize,
    isSelected,
    onToggle,
}) => {
    if (vendors.length === 0) {
        return (
            <>
                <ToolsRibbonComponent
                    totalCount={0}
                    pageIds={pageIds}
                    selectedCount={selectedCount}
                    pageSelectedCount={pageSelectedCount}
                    allSelected={false}
                    onSelectAll={() => {}}
                    onSelectPage={() => {}}
                    onClear={() => {}}
                />
                <NoResults
                    hasActiveFilter={hasActiveFilter}
                    totalCount={totalCount}
                    allSelected={allSelected}
                    onSelectAll={onSelectAll}
                    onClearAll={onClearSelection}
                />
            </>
        );
    }

    return (
        <>
            <ToolsRibbonComponent
                totalCount={totalCount}
                pageIds={pageIds}
                selectedCount={selectedCount}
                pageSelectedCount={pageSelectedCount}
                allSelected={allSelected}
                onSelectAll={onSelectAll}
                onSelectPage={onSelectPage}
                onClear={onClearSelection}
            />
            <Table borderedColumns={true}>
                <VendorManagementTableHeader
                    totalCount={totalCount}
                    allSelected={allSelected}
                    onSelectAll={onSelectAll}
                    onClearAll={onClearSelection}
                />
                <Body>
                    {vendors.map((vendor, index) => (
                        <VendorManagementTableRow
                            key={vendor.id}
                            vendor={vendor}
                            index={index}
                            pageSize={pagination.size}
                            currentPage={pagination.page}
                            selected={isSelected(vendor.id)}
                            onToggle={(checked, shiftKey) => onToggle(vendor.id, index, checked, shiftKey)}
                        />
                    ))}
                </Body>
            </Table>
            <div style={{padding: '1rem 2rem'}}>
                <VendorManagementPagination
                    pagination={pagination}
                    totalCount={totalCount}
                    onChangePage={onChangePage}
                    onChangePageSize={onChangePageSize}
                />
            </div>
        </>
    );
};
